import React, {FC, ReactNode} from 'react';

import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {ClientAtom} from '../../../editors/expressions/expressionAtomModel';
import {buildAtomDescription} from '../../../editors/expressions/expressionInferHelpers';
import {MultilineRuleParameterCardDefaultTitleStyled} from '../ruleMultilineParameterCard';
import {AtomLine} from './atomLine';

export interface AtomTitleProps {
  atom: ClientAtom;
  title?: ReactNode;
}

export const AtomTitle: FC<AtomTitleProps> = (props) => {
  const theme = useUserTheme();
  const {atom, title, children} = props;
  const {name, tooltip} = buildAtomDescription(atom);

  return (
    <MultilineRuleParameterCardDefaultTitleStyled>
      <AtomLine>
        <span>{title || name}</span>
        {children}
        {tooltip && <TooltipCoordinator iconColor={theme.greys.shade70} render={() => tooltip} />}
      </AtomLine>
    </MultilineRuleParameterCardDefaultTitleStyled>
  );
};
